export default __webpack_public_path__ + "static/media/twitter.03c1ee7c.svg";